import React, { useState, useCallback } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { get, isNil } from 'lodash';

import Lobby from './containers/Lobby';
import Game from './containers/Game';
import InstallPrompt from './components/InstallPrompt';
import { loadAuthForRoom, saveAuth, clearAuth } from './lib/sessionAuth';
import './App.css';

function emptyAuth() {
  return {
    playerID: null,
    credentials: null,
    roomID: null,
    name: '',
    hostConfig: null,
  };
}

function App() {
  // Do not hydrate from localStorage into React state on first paint for "/" —
  // only restore when opening a specific room URL (refresh mid-game).
  const [auth, setAuthState] = useState(emptyAuth);

  const setAuth = useCallback((next) => {
    const normalized = {
      playerID: next.playerID != null ? String(next.playerID) : null,
      credentials: next.credentials || null,
      roomID: next.roomID ? String(next.roomID).toUpperCase() : null,
      name: next.name || '',
      hostConfig: next.hostConfig || null,
    };
    setAuthState(normalized);
    if (
      !isNil(normalized.playerID) &&
      !isNil(normalized.credentials) &&
      normalized.roomID
    ) {
      saveAuth(normalized);
    }
  }, []);

  const resetAuth = useCallback(() => {
    clearAuth();
    setAuthState(emptyAuth());
  }, []);

  return (
    <div className="App">
      <InstallPrompt />
      <Router>
        <Switch>
          <Route
            path="/:id"
            render={({ location, match }) => {
              const roomID = get(match, 'params.id');
              const upper = roomID ? String(roomID).toUpperCase() : null;
              const saved = upper ? loadAuthForRoom(upper) : null;

              const memOk =
                upper &&
                auth.roomID === upper &&
                !isNil(auth.credentials) &&
                !isNil(auth.playerID);

              const active = memOk ? auth : saved;

              if (
                active &&
                upper &&
                active.roomID === upper &&
                !isNil(active.credentials) &&
                !isNil(active.playerID)
              ) {
                return (
                  <Game
                    auth={active}
                    setAuth={setAuth}
                    resetAuth={resetAuth}
                  />
                );
              }

              return (
                <Redirect
                  to={{
                    pathname: '/',
                    state: {
                      from: location,
                      roomID: upper,
                      name: get(saved, 'name', ''),
                    },
                  }}
                />
              );
            }}
          />
          <Route path="/">
            <Lobby setAuth={setAuth} resetAuth={resetAuth} />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
